/* eslint no-unused-vars: "off" */
/* eslint camelcase: "off" */
import axios from 'axios';

const getDevAccessToken = () => {
  // actually using "TEST" env not dev

  axios
    .get('http://localhost:8010/dev-token')
    .then((resp: any) => {
      console.log(resp);
      const token = `"access_token":"${resp.data.access_token}"`;
      const expires_in = `"expires_in":"${resp.data.expires_in}"`;
      const token_type = `"token_type":"${resp.data.token_type}"`;
      const scope = `"scope":"${resp.data.scope}"`;
      const ckie = `{${token},${expires_in},${token_type},${scope}}`;
      document.cookie = `${'CVAccessToken ='}${ckie}`;
    })
    .catch((error: any) => {
      console.error(error);
      console.error('Error from Access Token test');
      return error;
    });
};

export { getDevAccessToken };
